// Glossaire Diag SCOP Prévention — story 17
// Source : .metier/V1_glossaire_diag SCOP.docx

export interface GlossaireEntry {
  terme: string
  definition: string
}

export interface GlossaireSection {
  titre: string
  description?: string
  entries: GlossaireEntry[]
}

export const GLOSSAIRE_RISQUES: GlossaireSection = {
  titre: 'Définition des risques',
  entries: [
    {
      terme: 'Ambiances thermiques et climatiques',
      definition:
        "Les conditions climatiques extérieures (canicule et gel), les variations de température (passage du chaud au froid et inversement) et les environnements de travail à températures excessives (fours, chambres froides) ont un impact important sur les conditions de travail et la santé des salariés exposés.",
    },
    {
      terme: 'Atteintes musculaires et articulaires',
      definition:
        "Les douleurs articulaires et musculaires (Troubles musculo-squelettiques, tendinites, lombalgies, sciatiques, etc.) peuvent être conséquentes au port manuel de charge, aux postures contraignantes et aux gestes répétés. Plusieurs facteurs viennent amplifier le phénomène (âge, chaud, froid, vibrations, travaux hyperbares, environnement, etc.). Elles conduisent à des maladies professionnelles souvent invalidantes.",
    },
    {
      terme: 'Basculement / Renversement',
      definition:
        "Le matériel ou des matériaux peuvent se renverser ou basculer suite à un déséquilibre dû à un défaut de stabilisation, d'amarrage, d'ancrage ou des appuis ; les effets du vent ; un choc et/ou une mauvaise manœuvre ; une mauvaise répartition de charge ; un dépassement des limites d'utilisation de l'engin ; etc.",
    },
    {
      terme: 'Bruit',
      definition:
        "Ensemble de sons perçus qui peuvent générer une sensation de gêne ou de douleur, une dégradation progressive ou brutale de l'ouïe pouvant entraîner une surdité. Le bruit peut être produit par l'utilisateur et/ou l'environnement du poste de travail.",
    },
    {
      terme: 'Chute de hauteur',
      definition:
        "Une chute de hauteur est une chute avec dénivellation depuis un plan ou équipement de travail, par exemple. Ces chutes constituent la principale cause d'accidents du travail graves et mortels dans le BTP.",
    },
    {
      terme: 'Chute de plain-pied',
      definition:
        "Une chute de plain-pied désigne les glissades, faux-pas, trébuchements ou pertes d'équilibre d'une personne sur une surface plane sans dénivelé significatif, qui conduisent à une chute ou à un déséquilibre mettant en danger la personne. Ce type de chute se produit au niveau du sol, sans qu'il y ait de chute depuis une hauteur ou un plan élevé.",
    },
    {
      terme: 'Coupure ou sectionnement',
      definition:
        "La mise en œuvre d'outils et de matériaux coupants ou tranchants, de machines de production (machines à bois, scies, plieuses, cisailles-guillotines, etc.), d'engins (mécanismes accessibles, par exemple une PEMP à ciseaux), ou de jets à haute pression (hydrojet), peut entraîner des blessures allant de la simple égratignure à l'amputation.",
    },
    {
      terme: 'Écrasement',
      definition:
        "L'écrasement provient d'une pression exercée sur tout ou partie du corps par une masse en mouvement (outil, objet, charge, élément de machine, véhicule ou engin, mise en tension d'élingues ou de câbles, etc.). Les extrémités des membres sont les plus exposées (mains, pieds).",
    },
    {
      terme: "Effondrement de l'ouvrage",
      definition:
        "L'effondrement de l'ouvrage peut être dû à une faiblesse dans la structure liée à un choc, un défaut de stabilisation ou de conception, ou un phénomène extérieur (ruptures, agressions climatiques chimiques ou attaques d'insectes). Il peut avoir comme conséquences chutes et écrasements.",
    },
    {
      terme: 'Ensevelissement',
      definition:
        "L'ensevelissement survient essentiellement sur les chantiers de terrassement lorsque la cohésion du terrain n'est pas garantie ou lors d'opérations de dévasage (travaux immergés). Des facteurs aggravent ce phénomène : vibrations, surcharges et homogénéité des sols, hygrométrie et températures, etc. Ce risque se traduit par le déplacement des masses de matériaux qui peuvent ensevelir les compagnons.",
    },
    {
      terme: 'Épidémie infectieuse',
      definition:
        "Des agents biologiques sont susceptibles de provoquer chez l'homme des infections (H1N1, Covid-19, etc.), allergies ou intoxications. Ces agents peuvent se propager dans la collectivité et être présents dans l'environnement, y compris dans les lieux de travail (chantiers, ateliers, bureaux, etc.) ou sur les éléments que l'on va manipuler et qui vont être contaminés (EPI usagés, outillage partagé, etc.).",
    },
    {
      terme: 'Gestion des secours',
      definition:
        "L'ensemble des moyens et actions destinés à assurer la sécurité des travailleurs en cas d'accident ou de malaise. Cela comprend la présence de matériel de premiers secours, la formation du personnel aux gestes d'urgence (SST), et l'affichage des consignes de sécurité. L'employeur organise et maintient ces dispositifs selon les risques du chantier.",
    },
    {
      terme: 'Heurt',
      definition:
        "Le heurt est un choc entre une personne et un obstacle ou une masse fixe ou en mouvement (outil, objet, charge, élément de machine, véhicule ou engin, embarcation, hélice, agitateur, etc.). Au moment du heurt, la personne peut être en station ou en mouvement à son poste de travail, ou en situation de déplacement (piéton). Le heurt, en fonction des circonstances, peut entraîner d'autres risques comme par exemple des chutes, des coupures ou des sectionnements.",
    },
    {
      terme: 'Hygiène',
      definition:
        "L'hygiène sur un chantier vise à offrir aux salariés des conditions de travail dignes et saines. Elle repose sur la présence et l'entretien d'une « base vie » : eau potable, sanitaires propres, vestiaires, espace de repas abrité et vêtements adaptés. Ces installations doivent être disponibles dès le début du chantier, quelle que soit sa taille.",
    },
    {
      terme: 'Incendie et/ou explosion',
      definition:
        "Tous les métiers du BTP peuvent être concernés par un départ de feu, en particulier ceux qui travaillent par point chaud et/ou qui utilisent des gaz, ou qui mettent à jour des réseaux en charge. Les incendies sont provoqués par des étincelles, des échauffements ou des explosions. Ces dernières sont souvent liées à une fuite de gaz, à des produits inflammables, à des poussières, à des explosifs, etc.",
    },
    {
      terme: 'Poussières et fibres',
      definition:
        "Les travaux sur des matériaux ou bâtiments existants sont susceptibles de libérer des poussières ou des fibres plus ou moins nocives. Certaines peuvent même provoquer des dégâts irrémédiables sur la santé, comme la silice, le plomb et l'amiante. Les poussières et fibres de l'environnement de travail (air, empoussièrement des locaux, etc.) sont également à prendre en compte.",
    },
    {
      terme: 'Produits et agents chimiques',
      definition:
        "Les agents chimiques sont présents dans tous les produits manufacturés en particulier dans les acides et décapants, solvants et diluants, peintures, vernis et colles, résines et ciments, produits phytosanitaires. Certains matériaux peuvent aussi contenir des agents chimiques. En fonction de leurs concentrations ou associations, ils peuvent être plus ou moins dangereux, voire très dangereux pour les CMR (Cancérigènes, Mutagènes, toxiques pour la Reproduction), par exemple.",
    },
    {
      terme: 'Risque électrique',
      definition:
        "L'électricité est invisible mais dangereuse. Tout contact, direct ou indirect, avec le courant électrique peut avoir comme conséquences des brûlures, un arrêt cardio-respiratoire voire la mort dans les cas les plus graves (électrocution). Les compagnons peuvent y être confrontés dans les locaux existants et/ou à proximité des réseaux en charge (aériens et enterrés).",
    },
    {
      terme: 'Risque routier sur voie publique',
      definition:
        "La conduite sur route est de loin l'activité qui génère le plus d'accidents graves. Tous les salariés véhiculés sont exposés (trajets et missions, transport en commun, transport de matériel et matériaux, etc.). Ce risque peut provenir du véhicule (VUL, PL, attelages), et/ou des charges transportées (arrimage), et/ou des comportements individuels (conducteurs, passagers) et/ou de l'environnement (tiers ou usagers).",
    },
    {
      terme: 'Vibrations mécaniques',
      definition:
        "Les vibrations sont transmises par les machines ou les véhicules et engins, soit à l'ensemble du corps, soit sur une partie, le plus souvent les membres supérieurs. Elles favorisent l'apparition de troubles musculosquelettiques (TMS) et peuvent engendrer des maladies professionnelles quelquefois invalidantes.",
    },
  ],
}

export const GLOSSAIRE_THEMES: GlossaireSection = {
  titre: 'Définition des thèmes',
  entries: [
    {
      terme: 'Hygiène',
      definition:
        "C'est un sujet de conformité et de conditions de travail qui est structurant mais qui est moins lié à la gravité immédiate.",
    },
    {
      terme: 'Risque routier sur voie publique',
      definition:
        "C'est la 1ère cause de mortalité liée au travail. Au-delà de la conduite proprement dite, les sujets de l'arrimage et de l'entretien de la flotte de véhicules sont des priorités à aborder.",
    },
    {
      terme: 'Atteintes musculaires et articulaires',
      definition:
        "Les cas de Troubles Musculo-Squelettiques (TMS) sont fréquents. Il y a des gains rapides à obtenir avec la mise à disposition de moyens de manutention et d'organisation des approvisionnements. Des aides financières sont possibles avec le dispositif FIPU de la CNAM.",
    },
    {
      terme: 'Chute de hauteur',
      definition:
        "La 1ère cause de décès dans le BTP. L'attention doit être portée sur les protections collectives, l'existence d'accès sûrs, la substitution des escabeaux par des PIRL par exemple.",
    },
    {
      terme: 'Coupure ou sectionnement',
      definition:
        "Sur les chantiers les coupures/sectionnements peuvent provoquer des blessures immédiates graves (amputation, section d'artère, hémorragie, incapacité) et surviennent fréquemment lors d'utilisation d'outils portatifs, machines ou manutention de matériaux tranchants.",
    },
    {
      terme: 'Bruit',
      definition:
        "C'est un risque majeur et omniprésent sur chantier (acouphènes, perte auditive irréversible, stress, effets cardiovasculaires), mais il agit plutôt par exposition cumulative (effet à moyen/long terme) plutôt que par blessure immédiate.",
    },
    {
      terme: 'Risque électrique',
      definition:
        "Un risque qui reste fatal. Les formations réglementaires sur le risque électrique sont utiles, le choix des bons EPI et les opérations de consignation avant travaux et/ou les protections différentielles sont efficaces.",
    },
    {
      terme: 'Urgences et secours',
      definition:
        "L'affichage des consignes d'urgence, l'existence de trousses de secours par équipe, les extincteurs bien dimensionnés sont des moyens simples pour réduire la gravité résiduelle.",
    },
    {
      terme: 'Évaluation des risques',
      definition:
        "Le DUER matérialise votre connaissance des risques majeurs de votre activité. C'est un essentiel de votre gestion de la prévention. Il est mis à jour annuellement et après événement.",
    },
    {
      terme: "Plan d'action prévention",
      definition: "Ce document matérialise votre passage à l'action en prévention. Il complète le DUER.",
    },
    {
      terme: 'Fonctions supports',
      definition:
        "L'implication de vos collaborateurs en charge des RH et de l'administratif sont essentiels dans le suivi santé-sécurité. La connaissance de fondamentaux en Santé-Sécurité au Travail est un atout pour être efficace.",
    },
    {
      terme: 'Animateur prévention',
      definition:
        "Vous devez disposer de relais prévention. Désigner et former un ou des chargé(s) de prévention vous permet de pérenniser l'animation de la prévention.",
    },
    {
      terme: 'Compétences',
      definition:
        "Dans le BTP, la compétence (formation, qualification, habilitations, maîtrise des outils) est un pilier majeur de prévention. Elle influe sur la qualité des tâches, le respect des procédures et la capacité à repérer les dangers.",
    },
    {
      terme: 'Gestion générale des locaux, matériels et équipements de sécurité',
      definition:
        "Le maintien en état de conformité (extincteurs, issues de secours, rangements, signalisation, matériel de secours) est une exigence réglementaire et récurrente. Cependant, ce thème dépend surtout de l'organisation et cause rarement un accident immédiat en lui-même.",
    },
    {
      terme: 'Dossier chantier',
      definition:
        "Le dossier chantier (Plan d'installation de chantier, DICT, PPSPS, consignes, plans de phasage…) est essentiel pour une prévention structurée, mais son impact est indirect : un dossier incomplet entraîne souvent un manque d'anticipation, mais pas un risque immédiat comme une coupure ou une absence de secours.",
    },
    {
      terme: 'Gestion des urgences',
      definition:
        "La capacité à réagir immédiatement en cas d'accident (hémorragie, chute, écrasement, arrêt cardiaque) conditionne directement la survie et la gravité des conséquences.",
    },
    {
      terme: 'Accueil nouveaux arrivants',
      definition:
        "Comment être prudent sans connaître son environnement de travail. L'accueil contribue à réduire les accidents de prise de poste.",
    },
    {
      terme: 'Analyses des accidents de travail (AT)',
      definition:
        "Pour s'améliorer en prévention, la connaissance des incidents/accidents est nécessaire. La mise en place d'un Registre des accidents bénins et le retour d'expérience par exemple alimente les choix d'actions efficaces.",
    },
    {
      terme: 'Audits, visites chantier',
      definition:
        "La visite sécurité d'un chantier est très utile pour vérifier la mise en place des fondamentaux et permet de stabiliser les pratiques collectives.",
    },
  ],
}

export const GLOSSAIRE_METHODES: GlossaireSection = {
  titre: 'Définition des méthodes HALTES, ORGA et BILAN',
  entries: [
    {
      terme: 'HALTES — H : Hygiène',
      definition:
        "Base vie adaptée : WC, douches, vestiaires, réfectoire. Vêtements de travail et EPI propres. Eau potable et chantier tenu en ordre.",
    },
    {
      terme: 'HALTES — A : Accès',
      definition:
        "Entrées et sorties du chantier sécurisées. Voies de circulation claires pour piétons, engins, véhicules. Escaliers, échelles et échafaudages sûrs.",
    },
    {
      terme: 'HALTES — L : Livraison / Approvisionnement',
      definition:
        "Zones de livraison et de stockage bien signalées et organisées. Matériaux rangés correctement. Moyens de levage et de manutention adaptés.",
    },
    {
      terme: 'HALTES — T : Tâches',
      definition:
        "Outils, machines et échafaudages conformes. Protections collectives (garde-corps, filets) et individuelles (casque, gants, harnais). Salariés formés et consignes affichées.",
    },
    {
      terme: 'HALTES — E : Énergies',
      definition:
        "Repérage et protection des réseaux aériens et enterrés. Installations électriques de chantier sécurisées. Utilisation correcte des câbles, rallonges et matériels électriques.",
    },
    {
      terme: 'HALTES — S : Secours',
      definition:
        "Extincteurs et trousses de secours accessibles et signalés. Salariés formés SST. Procédure claire d'alerte et point de rassemblement connu.",
    },
    {
      terme: 'ORGA — Orientations, Rôles et missions, Gestion des ressources, Animation',
      definition:
        "La méthode ORGA décrit de manière la plus exhaustive possible les processus, responsabilités et ressources nécessaires pour assurer la prévention des risques et la sécurité dans une entreprise. Cela couvre la stratégie, les rôles de chaque acteur, la gestion matérielle et humaine, ainsi que l'animation et la communication autour de la sécurité.",
    },
    {
      terme: 'BILAN — Bilan chantier et annuel, Indicateurs, Liens externes, Audits, Nouveautés',
      definition:
        "Il s'agit d'une structure de bilan pour le suivi des chantiers, avec différentes catégories classées sous le mot-clé BILAN. C'est un suivi global des chantiers et de l'entreprise permettant de garantir la sécurité, mesurer la performance, contrôler le respect des règles, collaborer avec les partenaires et intégrer innovations et retours d'expérience pour améliorer les pratiques au quotidien.",
    },
  ],
}

export const GLOSSAIRE_SECTIONS: GlossaireSection[] = [
  GLOSSAIRE_RISQUES,
  GLOSSAIRE_THEMES,
  GLOSSAIRE_METHODES,
]
